import { Info } from '@mui/icons-material';
import { IconButton, styled, SvgIconTypeMap, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import shadows from '@mui/material/styles/shadows';

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    slotProps={{
      popper: {
        modifiers: [{ name: 'offset', options: { offset: [0, -7] } }]
      }
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    // color: theme.palette.common.white,
    '&::before': {
      boxShadow: theme.shadows[2],
      backgroundColor: theme.palette.common.white,
      border: '1px solid #dadde9'
    }
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11
  }
}));

const Icons: { [Identifier: string]: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> } = { info: Info };

export const ToolTip = (props: { helpText: string; icon?: string; style?: any }) => {
  const { helpText, icon = 'info', style = {} } = props;
  const Icon = Icons[icon];
  return (
    <LightTooltip title={helpText} placement="bottom-start" arrow>
      <IconButton sx={{ padding: '0px', width: '15px', ...style }}>
        <Icon sx={{ width: '15px' }} />
      </IconButton>
    </LightTooltip>
  );
};

export const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    slotProps={{
      popper: {
        modifiers: [{ name: 'offset', options: { offset: [0, -7] } }]
      }
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    // color: theme.palette.common.white,
    '&::before': {
      backgroundColor: theme.palette.common.white,
      border: '1px solid #dadde9'
    }
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    maxWidth: 260,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
    boxShadow: theme.shadows[2]
  }
}));
